import { SitewideResultTypeEnum } from "@search/api/enums";
import type { SitewideResult } from "@search/api/types";
import { getSitewideResultUrl } from "@search/utils/sitewideResult";
import { TransformedSitewideResult } from "@search_v2/types";

export type NavigateToArgs = {
  destination?: TransformedSitewideResult;
  date?: string;
  nights?: string;
};

const getRedirectUrl = (
  destination?: SitewideResult,
  date?: string,
  nights?: string,
): string => {
  const baseUrl = destination ? getSitewideResultUrl(destination) : "/search";
  const url = new URL(baseUrl, window.location.origin);

  if (date) {
    const dateParam =
      destination?.type === SitewideResultTypeEnum.VENUE
        ? "arrival_date"
        : "date";
    url.searchParams.append(dateParam, date);
  }

  if (nights) {
    url.searchParams.append("nights", nights);
  }
  return `${url.pathname}${url.search}`;
};

export const redirectToResultPage = ({
  destination,
  date,
  nights,
}: NavigateToArgs) => {
  window.location.href = getRedirectUrl(destination, date, nights);
};
